import { render, staticRenderFns } from "./FacultyLeaveRequests.vue?vue&type=template&id=4c3ef286"
import script from "./FacultyLeaveRequests.vue?vue&type=script&lang=js"
export * from "./FacultyLeaveRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports